import { render, staticRenderFns } from "./personal-document-info.vue?vue&type=template&id=322f3160&scoped=true&"
import script from "./personal-document-info.vue?vue&type=script&lang=js&"
export * from "./personal-document-info.vue?vue&type=script&lang=js&"
import style0 from "./personal-document-info.vue?vue&type=style&index=0&id=322f3160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322f3160",
  null
  
)

export default component.exports